import $ from "../../../assets/js/jquery.js";

export function handleModalFocus(modalID) {
    $(`#${modalID}`).on('shown.bs.modal', () => {
        $('.modal-header button').focus();
        let buttons = document.querySelectorAll(`.modal-open .modal[role="dialog"]#${modalID} button`);
        buttons = Array.prototype.slice.call(buttons);
        buttons[buttons.length - 1].addEventListener('blur', () => {
            (<HTMLElement>buttons[0]).focus();
        });
    });
}

export function handleModalAnchorFocus(modalID) {
    $(`#${modalID}`).on('shown.bs.modal', () => {
        let buttons = document.querySelectorAll(`.modal-open .modal[role="dialog"]#${modalID} button`);
        buttons = Array.prototype.slice.call(buttons);
        buttons[0].addEventListener('blur', () => {
            $('.modal-footer a').focus();
        });
    });
}

export const _windowUtil = (window: any) => {
  function getWindowLocationHref(): string {
      return window.location.href;
  }
  function setWindowLocationHref(path: string): void {
      window.location.href = path;
  }

  function getWindowSearchParams(): URLSearchParams {
    return new URLSearchParams(window.location.search);
  }

  function getWindowLocationSearch(): string {
    return window.location.search;
  }

  function setWindowAssign(url): void {
    window.location.assign(url)
  }

  return {
      getWindowLocationHref: getWindowLocationHref,
      setWindowLocationHref: setWindowLocationHref,
      getWindowSearchParams: getWindowSearchParams,
      getWindowLocationSearch: getWindowLocationSearch,
      setWindowAssign: setWindowAssign
  }
}

export const findNestedObj = (obj, keyToFind) => {
  let foundObj;
  JSON.stringify(obj, (_, nestedValue) => {
    if (nestedValue && nestedValue[keyToFind]) {
      foundObj = nestedValue[keyToFind];
    }
    return nestedValue
  });
  return foundObj;
};

export const pluralizeBannerName = (banner: string): string => {
  banner = banner[0].toUpperCase() + banner.slice(1);
  if (banner.endsWith('s')) {
    return banner;
  }
  return `${banner}'s`;
}